import { environment } from '../../../environments/environment';

export const APP_BRANDING = {
	isDemo: environment.demo,
	name: environment.demo ? 'MEDDATA' : 'ICORS'
} as const;
